<main *ngIf="showContent"id="main-content" tabindex="-1">
	<div class="hero">
		<img src="https://langtons-house.vercel.app/assets/img/hero-booking.jpg" alt="The foyer at Langtons House">
		<div class="hero__wrap">
			<p class="crumb"><a href="https://langtons-house.vercel.app/index.html">Home</a> / Check availability</p>
			<p class="lab">01 - Booking</p>
			<h1>Ceremonies in Havering</h1>
		</div>
		
	</div>
	<section class="govuk-width-container">
			<div class="govuk-grid-row">
			<div class="govuk-grid-column-full">
				<h2 class="mb-3">
					{{ startPageSubtitle }}
				</h2>

				<div [innerHTML]="startPageSubtitleBody"></div>

				<div class="button-container">
					<button class="btn btn-primary" (click)="startBooking()">
						Book your ceremony
					</button>
				</div>
			</div>
		</div>
	</section>
	
</main>
